import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface SidebarTabFocus {
  kind: 'chat' | 'session'
  id: string
}

export interface SidebarTabsState {
  focused: SidebarTabFocus | null
}

const initialState: SidebarTabsState = {
  focused: null
}

const sidebarTabsSlice = createSlice({
  name: 'sidebarTabs',
  initialState,
  reducers: {
    setSidebarFocus(state, action: PayloadAction<SidebarTabFocus | null>) {
      state.focused = action.payload
    }
  }
})

interface SidebarTabsRootState {
  sidebarTabs: SidebarTabsState
}

export const { setSidebarFocus } = sidebarTabsSlice.actions

export function selectSidebarFocus(state: SidebarTabsRootState): SidebarTabFocus | null {
  return state.sidebarTabs.focused
}

export default sidebarTabsSlice.reducer
